<template>
  <div>
    <unicom-tabela
      iconeMensagemVazia="map-pin"
      mensagemVazia="Nenhum endereço encontrado"
      mostrarNovoBlocoVazio
      :subtituloMensagemVazia="subtituloMensagemVazia"
      :alturaBody="378.4"
      :icones="[]"
      :itensPorPagina="['09', '18', '27']"
      itemSelecionadoProp="09"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :rows="rows"
      :cabecalho="[]"
      :carregamento="loadingTabela"
      textoExibindo="resultados"
      :estruturaPadrao="false"
      tableLayout="fixed"
      @click-subtitulo-mensagem="limparFiltro"
      @troca-elemento-pagina="trocarElementoPagina"
      @troca-pagina="trocarPagina"
    >
      <div slot="header">
        <unicom-linha justificarItem="end">
          <unicom-coluna
            sm="12"
            md="auto"
            style="width: calc(100% - 244px)"
            class="pb-2"
          >
            <unicom-barra-pesquisa-v2
              @pesquisar="pesquisarEndereco"
              v-model="campoPesquisa"
              placeholder="Busque por um CNPJ ou código de referência..."
            />
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            md="auto"
            :class="$breakpoint.smAndDown ? 'pb-2' : ''"
          >
            <unicom-botao
              :bloco="$breakpoint.smAndDown"
              :largura="170"
              @click="mostrarFiltro = true"
              contornado
              nomeIcone="sliders"
              estiloIcone="transform: rotate(90deg);"
            >
              FILTRAR
              <div class="quantidade-filtro" v-if="quantidadeFiltro">
                {{ quantidadeFiltro }}
              </div>
            </unicom-botao>
          </unicom-coluna>
        </unicom-linha>
      </div>
      <div slot="rows">
        <unicom-linha :espacamento="false" style="width: 100%">
          <unicom-coluna
            sm="12"
            class="custom-flex-endereco"
            v-for="(row, index) in rows"
            :key="index"
          >
            <CartaoEndereco
              @click.native="abrirModalEndereco(index)"
              :objetoEndereco="row"
            />
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-tabela>
    <FiltroEndereco
      v-model="mostrarFiltro"
      @limpar-filtro="limparFiltro"
      @filtrar="filtrar"
      :listaTipoEndereco="listaTipoEndereco"
      :listaCidades="listaCidades"
    />
    <ModalEndereco
      :objetoModal="objetoModalEndereco"
      v-model="mostrarModalEndereco"
    />
  </div>
</template>

<script>
import CartaoEndereco from "../CartaoEndereco/CartaoEndereco";
import TabelaMixin from "@/shared/mixin/TabelaMixin";
import ModalEndereco from "../ModalEndereco/ModalEndereco";
import TabelaEnderecoMixin from "../TabelaEnderecoMixin";
import FiltroEndereco from "./FiltroEndereco";

export default {
  mixins: [TabelaMixin, TabelaEnderecoMixin],
  components: {
    CartaoEndereco,
    ModalEndereco,
    FiltroEndereco
  },
  data() {
    return {
      campoPesquisa: "",
      mostrarModalEndereco: false
    };
  }
};
</script>

<style lang="scss" scoped>
.custom-flex-endereco {
  padding-bottom: 2%;

  @media (min-width: 768px) {
    -webkit-box-flex: 0 !important;
    -ms-flex: 0 0 48% !important;
    flex: 0 0 48% !important;
    max-width: 48% !important;

    &:not(:nth-child(2n + 1)) {
      margin-left: calc((100% - (48% * 2)) / 1);
    }
    &:nth-child(2n + 1) {
      margin-left: 0;
    }
  }

  @media (min-width: 1050px) {
    -webkit-box-flex: 0 !important;
    -ms-flex: 0 0 32% !important;
    flex: 0 0 32% !important;
    max-width: 32% !important;

    &:not(:nth-child(3n + 1)) {
      margin-left: calc((100% - (32% * 3)) / 2);
    }

    &:nth-child(3n + 1) {
      margin-left: 0;
    }
  }

  @media (min-width: 1600px) {
    -webkit-box-flex: 0 !important;
    -ms-flex: 0 0 24% !important;
    flex: 0 0 24% !important;
    max-width: 24% !important;

    &:not(:nth-child(4n + 1)) {
      margin-left: calc((100% - (24% * 4)) / 3);
    }

    &:nth-child(4n + 1) {
      margin-left: 0;
    }
  }
}
</style>
